import { ScoreGradeLevel } from "../../machines/studentExperience/types"
import { getSchoolYear } from "../../../mp-utils/generic-utils"
import { getCustomToken } from "../../../mp-core/helpers/customToken"
import queryString from "query-string"
import { LicensesSet } from "../../../mp-database"

export const getCorrectRate = (correct: number): string => {
  if (correct <= 0.5) return "low"
  if (correct < 1) return "medium"
  return "high"
}

export const sortBySubject = (item1, item2): number =>
  item1.subject.localeCompare(item2.subject)

// TODO: This is how we get score?
export const getPracticeTestScore = (
  gradeLevels?: ScoreGradeLevel[],
  score?: number
): string => {
  const scoreGradeLevels = gradeLevels ?? []
  const scoreValue = score ?? -1

  return scoreGradeLevels.reduce(
    (grade, level) => (scoreValue >= level.score ? level.name : grade),
    "Did not take"
  )
}

export const checkUrlForExternal = (url: string) => {
  try {
    const redirectUrlEntity = new URL(url, document.baseURI)
    return window.location.origin !== redirectUrlEntity.origin
  } catch (_error) {
    return false
  }
}

export const redirectToExternalUrl = async (
  redirectUrl: string,
  userId: string,
  currentProgram: string,
  subjectPath: string
) => {
  // Pentest finding #2: token is in memory; wait for it after a reload
  const customToken = await getCustomToken()
  const fallbackCallbackUrl = `${window.location.origin}/student-experience/study-plan/${currentProgram}/${subjectPath}`

  const redirectUrlEntity = new URL(redirectUrl)
  const query = queryString.parse(redirectUrlEntity.search)
  const queryStr = queryString.stringify({
    ...query,
    customToken,
    callbackUrl: query.callbackUrl || fallbackCallbackUrl,
    userId: userId,
    schoolYear: getSchoolYear().year,
    attempt: 1
  })

  redirectUrlEntity.search = queryStr
  window.open(redirectUrlEntity.toString(), "_self")
}

export const isProgramFromStudyPlan = (
  program: string,
  userLicenses: LicensesSet[]
) => {
  if (!program || !userLicenses?.length) return null

  const programUpperCase = program.toUpperCase()

  return !!userLicenses?.find(
    license =>
      license.navName.split(" ").includes(programUpperCase) &&
      license.navCategory === "Study Plan"
  )
}
